export function showBatchesStorageLocationCheck(val) {
  return (
    val == "Plant Material" ||
    val == "Flower" ||
    val == "Prepack" ||
    val == "Preroll" ||
    val == "Seed" ||
    val == "Live Plant" ||
    val == "Bulk Extract" ||
    val == "Extract" ||
    val == "Cartridge" ||
    val == "Edibles & Drink" ||
    val == "Tincture" ||
    val == "Topicals & Wellness" ||
    val == "Pack To Order" ||
    val == "Merchandise"
  );
}

export function showTestDateCheck(val) {
  return val == "Plant Material" || val == "Flower" || val == "Prepack" || val == "Preroll" || val == "Pack To Order";
}

export function showBatchZoneCheck(val, industry) {
  return (
    (val == "Plant Material" ||
      val == "Flower" ||
      val == "Prepack" ||
      val == "Preroll" ||
      val == "Seed" ||
      val == "Live Plant" ||
      val == "Pack To Order") &&
    // || val == 'Bulk Extract'
    industry != "cannabis"
  );
}
export function showBatchLotCheck(val, industry) {
  return (
    (val == "Plant Material" ||
      val == "Flower" ||
      val == "Prepack" ||
      val == "Preroll" ||
      val == "Seed" ||
      val == "Live Plant" ||
      val == "Pack To Order") &&
    // || val == 'Bulk Extract'
    industry != "cannabis"
  );
}
export function showBatchSackCheck(val, industry) {
  return (
    (val == "Plant Material" || val == "Flower" || val == "Prepack" || val == "Preroll" || val == "Seed" || val == "Pack To Order") &&
    // || val == 'Bulk Extract'
    industry != "cannabis"
  );
}
export function showBatchSeededCheck(val, industry) {
  return (val == "Plant Material" || val == "Flower" || val == "Prepack") && industry != "cannabis";
}
export function showBatchHarvestDateCheck(val) {
  return val == "Plant Material" || val == "Flower" || val == "Prepack" || val == "Preroll" || val == "Pack To Order" || val == "Seed";
}
export function showBatchDryDateCheck(val, industry) {
  return (val == "Plant Material" || val == "Flower" || val == "Prepack" || val == "Preroll" || val == "Pack To Order") && industry != "cannabis";
}
export function showBatchExtractionDateCheck(val) {
  return val == "Bulk Extract" || val == "Extract" || val == "Cartridge";
}
export function showBatchBestByDateCheck(val) {
  return (
    val == "Plant Material" ||
    val == "Flower" ||
    val == "Prepack" ||
    val == "Preroll" ||
    val == "Seed" ||
    val == "Live Plant" ||
    val == "Bulk Extract" ||
    val == "Extract" ||
    val == "Cartridge" ||
    val == "Edibles & Drink" ||
    val == "Tincture" ||
    val == "Topicals & Wellness" ||
    val == "Pack To Order"
  );
}
export function showProductionDateCheck(val) {
  return val == "Edibles & Drink" || val == "Tincture" || val == "Topicals & Wellness" || val == "Preroll";
}
export function showBatchPredominateCanabinoidDetailsCheck(val) {
  return (
    val == "Plant Material" ||
    val == "Flower" ||
    val == "Prepack" ||
    val == "Preroll" ||
    val == "Seed" ||
    val == "Live Plant" ||
    val == "Bulk Extract" ||
    val == "Extract" ||
    val == "Cartridge" ||
    val == "Edibles & Drink" ||
    val == "Tincture" ||
    val == "Topicals & Wellness" ||
    val == "Pack To Order"
  );
}
export function showBatchTerpenesCheck(val) {
  return (
    val == "Plant Material" ||
    val == "Flower" ||
    val == "Prepack" ||
    val == "Preroll" ||
    val == "Seed" ||
    val == "Live Plant" ||
    val == "Bulk Extract" ||
    val == "Extract" ||
    val == "Cartridge" ||
    val == "Edibles & Drink" ||
    val == "Tincture" ||
    val == "Topicals & Wellness" ||
    val == "Pack To Order"
  );
}
export function showBatchAdditionalCannabinoidsCheck(val) {
  return (
    val == "Plant Material" ||
    val == "Flower" ||
    val == "Prepack" ||
    val == "Preroll" ||
    val == "Seed" ||
    val == "Live Plant" ||
    val == "Bulk Extract" ||
    val == "Extract" ||
    val == "Cartridge" ||
    val == "Edibles & Drink" ||
    val == "Tincture" ||
    val == "Topicals & Wellness" ||
    val == "Pack To Order"
  );
}
export function showTHCLimitCheck(val, industry) {
  return val != "Merchandise" && industry != "cannabis";
}
export function showBatchDocumentsUploadFieldCheck(val) {
  return val != "Merchandise";
}
